import PanelStorage from "../storage/panel-storage";

export default function reducer(state = PanelStorage, action) {
  switch (action.type) {
    case "SET_KIND": {
      let newState = { ...state };
      newState.setKind(action.payload);
      newState.resetQuery();
      return newState;
    }
    case "SET_MAKE": {
      let newState = { ...state };
      newState.setMake(action.payload);
      newState.resetQuery();
      return newState;
    }
    case "SET_ORDER": {
      let newState = { ...state };
      newState.setOrder(action.payload);
      return newState;
    }
    case "SET_PAGESIZE": {
      let newState = { ...state };
      newState.setPageSize(action.payload);
      return newState;
    }
    case "SET_QUERY": {
      let newState = { ...state };
      newState.setQuery(action.payload);
      return newState;
    }
    default: return state;
  }
}
